import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

const HtmlForm = {
  default_Id: "",
  column_Split: "",
  file_Alignment: "",
  html: "",
  status: true,
};

//create slice
const name = "editor";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports
export const editorActions = { ...slice.actions, ...extraActions };
export const editorReducer = slice.reducer;

function createInitialState() {
  return {
    defaultHtml: [],
    loading: false,
  };
}

function createReducers() {
  return {};
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return { getHtmlContent: getHtmlContent() };

  /* get categories by Committee_ID */
  function getHtmlContent() {
    return createAsyncThunk(
      `${name}/getHtmlContent`,
      async () => await fetchWrapper.get(`${baseUrl}/category/committee/`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(editorActions.getHtmlContent.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(editorActions.getHtmlContent.fulfilled, (state, action) => {
      state.loading = false;
      state.defaultHtml = action.payload;
    })
    .addCase(editorActions.getHtmlContent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    });
}
